<template>
  <div>
    <PersonalDetail v-if="pageType === pageConfig.personal.type" />
    <EnterpriseDetail v-if="pageType === pageConfig.enterprise.type" />
  </div>
</template>

<script>
import { PAGE_CONFIG } from './config'
import PersonalDetail from './personalDetail.vue'
import EnterpriseDetail from './enterpriseDetail.vue'

export default {
  data() {
    return {
      pageType: '',
      pageConfig: PAGE_CONFIG,
    }
  },
  methods: {
    initPageType() {
      const { path } = this.$route

      let pageType = ''
      if (path.includes(this.pageConfig.personal.type)) {
        pageType = this.pageConfig.personal.type
      } else if (path.includes(this.pageConfig.enterprise.type)) {
        pageType = this.pageConfig.enterprise.type
      }

      this.pageType = pageType
    },
  },
  created() {
    this.initPageType()
  },
  components: {
    PersonalDetail,
    EnterpriseDetail,
  },
}
</script>

<style lang="scss" scoped>

</style>
